import DataObjectField from "@/utilities/classes/data-object-field";

const buildFileSubmissionDataObject = vData => {
  const fields = [
    new DataObjectField(vData.fileName, 13),
    new DataObjectField(vData.recordID, 9),
    new DataObjectField(vData.fileURL, 7),
    new DataObjectField(vData.fileType, 6),
  ];

  const dataObject = {
    qdbapi: {
      udata: "SHARC_FILE_UPLOAD",
      apptoken: "dsgdzckckic6iabhuap3kdyiwdgc",
      field: fields
    }
  };
  return dataObject;
};

export default buildFileSubmissionDataObject;